<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :types="fieldTypes" :board="this.board" :is-print="isPrint" class="mt-8"/>

    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 점검개요</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div>
          <div>점검기간</div>
          <date-selector-rang :is-print="isPrint" class="w-full" v-model="form.점검기간"></date-selector-rang>
        </div>
        <div class="writeGridLineItem">
          <div>점검대상 시설명</div>
          <p v-if="isPrint" class="print-input">{{ fieldNames }}</p>
          <field-selector v-else v-model="form.점검대상시설명" multiple/>
        </div>
        <div class="writeGridLineItem">
          <div>점검반</div>
          <p v-if="isPrint" class="print-input">{{ form.점검반 }}</p>
          <ml-input v-else v-model="form.점검반" class="w-full" />
        </div>
      </div>
    </div>

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="점검 결과 및 조치사항"
      class="mt-4"
      v-model="form.조치사항"
      :tableData="[
        { id: '구분', title: '구분', type: 'text', placeholder: '00사면' },
        { id: '점검결과', title: '점검 결과', type: 'textarea', placeholder: '⁃ 사면내 기울어진 수목 자생\n⁃ 절토사면내 누수 발생' },
        { id: '조치사항', title: '조치(해야 할) 사항', type: 'textarea', placeholder: '⁃ 수목 제거 필요\n⁃ 민간전문가 합동점검 필요' },
      ]"
      :mobile="['구분']"
    />

    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 조치 계획</h5>
        </vs-col>
      </vs-row>

      <div class="mt-4">
        <p v-if="isPrint" class="print-textarea">{{ form.조치계획 }}</p>
        <ml-textarea v-else v-model="form.조치계획" class="w-full" placeholder="❍ 점검결과에 따른 조치사항 소관부서에 통보
❍ 시설물 점검결과에 따른 조치 사항 이행여부 확인 및 점검"/>
      </div>
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
      :showFooterInput="false"
      showCustom
    >
      <template v-slot:custom="{index}" >
        <div>
          <div class="w-full flex gap-3 items-center mt-2">
            <span class="whitespace-no-wrap" style="font-weight: 500">날짜</span>
            <span v-if="isPrint" class="print-input">{{ form.photoList[index].date }}</span>
            <date-selector v-else v-model="form.photoList[index].date" :readonly="board.readonly" class="flex-1"/>
            <span class="whitespace-no-wrap" style="font-weight: 500">장소</span>
            <span v-if="isPrint" class="print-input">{{ form.photoList[index].place }}</span>
            <ml-input v-else v-model="form.photoList[index].place" :readonly="board.readonly" class="w-full flex-1"/>
          </div>
        </div>
        <div class="w-full flex gap-3 items-center mt-2">
          <span class="whitespace-no-wrap" style="font-weight: 500">내용</span>
          <span v-if="isPrint" class="print-input">{{ form.photoList[index].input }}</span>
          <ml-input v-else v-model="form.photoList[index].input" :readonly="board.readonly" class="w-full flex-1"/>
        </div>
      </template>
    </PhotoUploadGridModule>
    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import TableCustom from "@/components/TableCustom.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";

export default {
  components: {
    FieldSelector,
    DateSelector,
    PhotoUploadGridModule,
    TableCustom,
    DateSelectorRang,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    fieldTypes() {
      return ["com_name", "rank", "writer_name", "date"];
    },
    fieldNames() {
      const fields = this.form.점검대상시설명.map((item) => {
        return item.field_name;
      });
      return fields.join(", ");
    }
  },
  data() {
    return {
      allCheck: false,
      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],

        점검기간: {},
        점검대상시설명: [],
        점검반: "",

        조치사항: [
          {
            id: 1,
            구분: "",
            점검결과: "",
            조치사항: "",
          },
          {
            id: 2,
            구분: "",
            점검결과: "",
            조치사항: "",
          },
        ],
        조치계획: "",

      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },

};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead {
    th {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;

      background: #f9f9f9;
      border: solid #cdcdcd 1px;
      padding: 6px;
    }
  }
  tbody {
    tr {
      td {
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
        padding: 5px;
        border: solid #cdcdcd 1px;

        div {
          align-items: center;
        }
      }
    }
  }
}
</style>
